import { render, staticRenderFns } from "./mc-header.tests.vue?vue&type=template&id=029842ca&scoped=true"
import script from "./mc-header.tests.vue?vue&type=script&lang=ts"
export * from "./mc-header.tests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029842ca",
  null
  
)

export default component.exports